(() => {
  const dataEl = document.getElementById("VariantInventory");
  if (!dataEl) return;

  let variants;
  try { variants = JSON.parse(dataEl.textContent); } catch { return; }
  const variantMap = new Map(variants.map(v => [String(v.id), v]));

  const clampIfNeeded = (variantId, requestedQty) => {
    const v = variantMap.get(String(variantId || ""));
    if (!v) return { qty: requestedQty, show: false, max: null };

    // Only enforce if inventory is managed AND overselling is not allowed
    if (!v.managed || v.policy === "continue") return { qty: requestedQty, show: false, max: null };

    const max = Number(v.qty || 0);
    if (requestedQty > max) return { qty: Math.max(max, 1), show: true, max };
    return { qty: requestedQty, show: false, max };
  };

  const findForm = () => document.querySelector('form[data-type="add-to-cart-form"]');
  const findQty = (form) => form?.querySelector('input[name="quantity"], [name="quantity"]');
  const findVariantId = (form) => form?.querySelector('input[name="id"]');
  const findWarning = (form) => form?.querySelector('[data-inventory-warning]');

  const update = () => {
    const form = findForm();
    if (!form) return;

    const qtyEl = findQty(form);
    const idEl = findVariantId(form);
    const warnEl = findWarning(form);

    if (!qtyEl || !idEl || !warnEl) return;

    const requested = parseInt(qtyEl.value || "1", 10) || 1;
    const res = clampIfNeeded(idEl.value, requested);

    // Helpful max attr for +/- controls
    if (res.max != null) qtyEl.setAttribute("max", String(Math.max(res.max, 1)));

    if (res.show) {
      qtyEl.value = String(res.qty);
      warnEl.textContent = `Only ${res.max} available right now — we’ve adjusted your quantity.`;
      warnEl.classList.remove("hidden");
    } else {
      warnEl.textContent = "";
      warnEl.classList.add("hidden");
    }
  };

  const bindOnce = () => {
    const form = findForm();
    if (!form || form.__invBound) return;
    form.__invBound = true;

    form.addEventListener("change", (e) => {
      if (e.target?.name === "quantity" || e.target?.name === "id") update();
    });
    form.addEventListener("input", (e) => {
      if (e.target?.name === "quantity") update();
    });
    form.addEventListener("submit", () => update());

    update();
  };

  bindOnce();
  new MutationObserver(bindOnce).observe(document.documentElement, { childList: true, subtree: true });
})();
